import { createRoot } from "react-dom/client";
import { PopupAlert } from "../atoms/PopupAlert";

const body = document.querySelector("body");
const confirmRoot = document.createElement("div");
body?.appendChild(confirmRoot);

interface Props {
  text: string;
  title?: string;
  options?: {
    buttonText?: string;
  };
}

interface AlertProps {
  text: string;
  subText?: string;
  title?: string | undefined;
  options?: {
    buttonText?: string | undefined;
  };
  giveAnswer: (answer: boolean) => void;
}

function Alert({ title, text, subText, giveAnswer, options }: AlertProps) {
  return (
    <PopupAlert
      title={subText ? "" : title ?? "알림"}
      text={text}
      subText={subText}
      buttons={
        <>
          <button
            className="confirm_btn"
            onClick={() => giveAnswer(true)}
            autoFocus
          >
            {options?.buttonText ? options?.buttonText : "확인"}
          </button>
        </>
      }
    ></PopupAlert>
  );
}

export const showAlert = (
  text: string,
  subText?: string,
  alertOptions?: Props
): Promise<boolean> =>
  new Promise((res) => {
    const root = createRoot(confirmRoot);

    const giveAnswer = (answer: boolean) => {
      root.unmount();
      res(answer);
    };

    root.render(
      <Alert
        title={alertOptions?.title}
        text={text}
        subText={subText}
        giveAnswer={giveAnswer}
        options={{
          buttonText: alertOptions?.options?.buttonText,
        }}
      />
    );
  });
